export default {
  // Navigation
  'nav.home': 'Inicio',
  'nav.about': 'Acerca de',
  'nav.retreat_details': 'Detalles del Retiro',
  'nav.experiences': 'Experiencias',
  'nav.schedule': 'Horario',
  'nav.reserve': 'Reservar',

  // Hero Section
  'hero.label': 'Retiro de Bienestar',
  'hero.title': 'Swasthya',
  'hero.subtitle': 'Donde la India Antigua se Encuentra con la Curación Isleña',
  'hero.tagline': 'Reconecta, Restaura y Reequilibra en Fuerteventura',
  'hero.description': 'Descubre un retiro de 3 noches y 4 días que armoniza tu mente, cuerpo y alma a través de la sabiduría de las antiguas tradiciones de bienestar indias, en los paisajes serenos de Fuerteventura.',
  'hero.cta': 'Comienza Tu Viaje',

  // About Section
  'about.label': 'Descubre Swasthya',
  'about.title': 'Por Qué Swasthya es Único',
  'about.expert.title': 'Guía Experta',
  'about.expert.description': 'Un equipo de especialistas de India y España, combinando Ayurveda, yoga, pranayama y prácticas centradas en el corazón con experiencias basadas en la naturaleza y el agua.',
  'about.holistic.title': 'Curación Holística',
  'about.holistic.description': 'Terapias ayurvédicas que equilibran los doshas, cocina sattvic, yoga, meditación y movimiento consciente para restaurar tu energía y vitalidad.',
  'about.nature.title': 'Inmersión en la Naturaleza',
  'about.nature.description': 'Experimenta una conexión consciente con playas, dunas y vientos, mejorando tu viaje de bienestar a través de la belleza natural de Fuerteventura.',
  'about.personalized.title': 'Enfoque Personalizado',
  'about.personalized.description': 'Cada práctica y tratamiento está adaptado a tu constitución única, asegurando el máximo equilibrio y rejuvenecimiento para tus necesidades individuales.',
  'about.founder.intro': 'El Retiro Swasthya está dirigido por',
  'about.founder.name': 'Mala Krishnani',
  'about.founder.description': ', una visionaria del bienestar holístico de India. Con más de 20 años de experiencia como profesora de yoga, también es especialista en acupresión y acupuntura, maestra de Reiki y Suzok, experta en Ayurveda y facilitadora de retiros Vipassana, y ha enseñado extensamente en India, Medio Oriente y Europa. Combina la sabiduría tradicional india con prácticas holísticas para guiar una experiencia transformadora de mente y cuerpo.',
  'about.closing': 'En Swasthya, creemos que el verdadero bienestar proviene de la integración armoniosa de la sabiduría antigua con la comprensión moderna. Nuestro retiro está diseñado para proporcionarte las herramientas, el conocimiento y las experiencias necesarias para continuar tu viaje de bienestar mucho después de regresar a casa.',

  // Retreat Details Section
  'retreat.title': 'Detalles del Retiro',
  'retreat.subtitle': 'Tu Viaje de Transformación',
  'retreat.duration.title': 'Duración',
  'retreat.duration.description': 'Retiros de 7, 14 o 21 días diseñados para una transformación profunda',
  'retreat.accommodation.title': 'Alojamiento',
  'retreat.accommodation.description': 'Villas privadas de lujo con vistas a la naturaleza y comodidades modernas',
  'retreat.meals.title': 'Comidas',
  'retreat.meals.description': 'Tres comidas sattvic orgánicas diarias adaptadas a tu dosha',
  'retreat.treatments.title': 'Tratamientos',
  'retreat.treatments.description': 'Terapias ayurvédicas diarias incluyendo Abhyanga, Shirodhara y Panchakarma',
  'retreat.yoga.title': 'Yoga y Meditación',
  'retreat.yoga.description': 'Sesiones diarias de yoga, pranayama y meditación guiada',
  'retreat.consultation.title': 'Consultas',
  'retreat.consultation.description': 'Evaluaciones personalizadas con practicantes ayurvédicos certificados',

  // Experiences Section
  'experiences.title': 'Experiencias Transformadoras',
  'experiences.subtitle': 'Terapias Curativas Antiguas',
  'experiences.abhyanga.title': 'Abhyanga',
  'experiences.abhyanga.description': 'Masaje tradicional de cuerpo completo con aceites herbales calientes para desintoxicar y rejuvenecer',
  'experiences.shirodhara.title': 'Shirodhara',
  'experiences.shirodhara.description': 'Flujo continuo de aceite tibio sobre la frente para calmar profundamente la mente',
  'experiences.panchakarma.title': 'Panchakarma',
  'experiences.panchakarma.description': 'Programa completo de desintoxicación de cinco pasos para purificación profunda',
  'experiences.yoga.title': 'Yoga y Pranayama',
  'experiences.yoga.description': 'Prácticas diarias para equilibrar energía y mejorar la vitalidad',
  'experiences.meditation.title': 'Meditación Guiada',
  'experiences.meditation.description': 'Sesiones de atención plena para paz interior y claridad mental',
  'experiences.nutrition.title': 'Nutrición Ayurvédica',
  'experiences.nutrition.description': 'Comidas personalizadas preparadas según tu constitución única',

  // Schedule Section
  'schedule.title': 'Horario Diario',
  'schedule.subtitle': 'Un Día en Swasthya',
  'schedule.morning.title': 'Rutina Matutina',
  'schedule.morning.time': '6:00 AM - 9:00 AM',
  'schedule.morning.activities': 'Despertar temprano, Yoga y Pranayama, Meditación, Desayuno sattvic',
  'schedule.midday.title': 'Sesión de Medio Día',
  'schedule.midday.time': '9:00 AM - 1:00 PM',
  'schedule.midday.activities': 'Consulta ayurvédica, Tratamientos terapéuticos, Tiempo libre para reflexión',
  'schedule.afternoon.title': 'Tarde',
  'schedule.afternoon.time': '1:00 PM - 6:00 PM',
  'schedule.afternoon.activities': 'Almuerzo nutritivo, Descanso y relajación, Caminata por la naturaleza o actividades opcionales',
  'schedule.evening.title': 'Ritual Vespertino',
  'schedule.evening.time': '6:00 PM - 9:00 PM',
  'schedule.evening.activities': 'Yoga suave, Cena ligera, Meditación guiada, Tiempo de silencio',

  // Accommodation Gallery Section
  'accommodation.title': 'Nuestras Villas',
  'accommodation.subtitle': 'Santuarios de Lujo Inspirados en los Cinco Elementos',
  'accommodation.tierra.name': 'Villa Tierra',
  'accommodation.tierra.element': 'Elemento Tierra',
  'accommodation.tierra.description': 'Arraigada en estabilidad y nutrición, esta villa ofrece un refugio sereno con tonos terrosos y materiales naturales.',
  'accommodation.fuego.name': 'Villa Fuego',
  'accommodation.fuego.element': 'Elemento Fuego',
  'accommodation.fuego.description': 'Encendiendo transformación y energía, con colores cálidos y espacios vibrantes que inspiran pasión.',
  'accommodation.aire.name': 'Villa Aire',
  'accommodation.aire.element': 'Elemento Aire',
  'accommodation.aire.description': 'Ligera y aireada, diseñada para libertad y movimiento con espacios abiertos y vistas panorámicas.',
  'accommodation.agua.name': 'Villa Agua',
  'accommodation.agua.element': 'Elemento Agua',
  'accommodation.agua.description': 'Fluyendo con tranquilidad y gracia, con tonos azules calmantes y características acuáticas relajantes.',
  'accommodation.eter.name': 'Villa Éter',
  'accommodation.eter.element': 'Elemento Éter',
  'accommodation.eter.description': 'Conectando con el infinito, un espacio para contemplación profunda y despertar espiritual.',
  'accommodation.cta': 'Ver Detalles',

  // Reservation Section
  'reservation.title': 'Reserva Tu Lugar',
  'reservation.subtitle': 'Fechas: Marzo, Abril, Mayo, Junio',
  'reservation.description': 'Lugares limitados disponibles – asegura tu lugar ahora para embarcarte en un viaje de curación ayurvédica, vida consciente y transformación del alma.',
  'reservation.contact.label': '¿Preguntas? Llámanos directamente',
  'reservation.form.firstName': 'Nombre',
  'reservation.form.lastName': 'Apellido',
  'reservation.form.email': 'Correo Electrónico',
  'reservation.form.phone': 'Número de Teléfono',
  'reservation.form.duration': 'Duración del Retiro',
  'reservation.form.duration.placeholder': 'Selecciona la duración',
  'reservation.form.duration.4days': '4 Días (3 Noches) - €1,499',
  'reservation.form.duration.7nights': '7 Noches - €3,000',
  'reservation.form.date': 'Fecha de Retiro Preferida',
  'reservation.form.date.placeholder': 'Selecciona una fecha',
  'reservation.form.date.mar': '18-21 de Marzo, 2025',
  'reservation.form.date.apr': '2-5 de Abril, 2025',
  'reservation.form.date.may': '14-17 de Mayo, 2025',
  'reservation.form.date.jun': '11-14 de Junio, 2025',
  'reservation.form.accommodation': 'Preferencia de Alojamiento',
  'reservation.form.accommodation.placeholder': 'Selecciona alojamiento',
  'reservation.form.accommodation.private': 'Habitación Privada (+€300)',
  'reservation.form.accommodation.shared': 'Habitación Compartida',
  'reservation.form.accommodation.nopreference': 'Sin Preferencia',
  'reservation.form.dietary': 'Requisitos Dietéticos o Alergias Alimentarias',
  'reservation.form.dietary.placeholder': 'Por favor describe cualquier restricción dietética, alergia o preferencia',
  'reservation.form.health': 'Condiciones de Salud o Limitaciones Físicas',
  'reservation.form.health.placeholder': 'Por favor comparte cualquier condición de salud o limitación física que debamos conocer',
  'reservation.form.experience': 'Experiencia Previa con Yoga/Ayurveda',
  'reservation.form.experience.placeholder': 'Selecciona tu nivel de experiencia',
  'reservation.form.experience.beginner': 'Principiante Completo',
  'reservation.form.experience.some': 'Algo de Experiencia (1-2 años)',
  'reservation.form.experience.intermediate': 'Intermedio (3-5 años)',
  'reservation.form.experience.advanced': 'Avanzado (5+ años)',
  'reservation.form.requests': 'Solicitudes Especiales o Preguntas',
  'reservation.form.requests.placeholder': 'Cualquier solicitud especial, pregunta o información adicional que te gustaría compartir',
  'reservation.form.emergency': 'Nombre del Contacto de Emergencia',
  'reservation.form.emergencyPhone': 'Teléfono del Contacto de Emergencia',
  'reservation.form.terms': 'Acepto los términos y condiciones, entiendo que este retiro involucra actividades físicas y confirmo que estoy en buen estado de salud para participar. Reconozco que se requiere un depósito del 50% para asegurar mi reserva.',
  'reservation.form.submit': 'Reservar Mi Lugar',
  'reservation.form.submitting': 'Procesando...',
  'reservation.pricing.package': 'Paquete de Retiro',
  'reservation.pricing.experience': 'experiencia todo incluido',
  'reservation.pricing.upgrade': 'Mejora de Habitación Privada',
  'reservation.pricing.total': 'Monto Total',
  'reservation.pricing.secure': 'Pago seguro procesado por Stripe',
  'reservation.info.payment': 'Pago Seguro',
  'reservation.info.payment.desc': 'Pago completo procesado de forma segura a través de Stripe',
  'reservation.info.booking': 'Reserva Flexible',
  'reservation.info.booking.desc': 'Cancelación gratuita hasta 14 días antes de la fecha del retiro',
  'reservation.info.support': 'Soporte Personal',
  'reservation.info.support.desc': 'Coordinador de retiro dedicado para ayudar con todos los arreglos',

  // Footer
  'footer.tagline': 'Tu viaje hacia el bienestar holístico comienza aquí',
  'footer.brand.line1': 'Retiro de bienestar ayurvédico en Fuerteventura',
  'footer.brand.line2': 'La sabiduría antigua se encuentra con la curación moderna',
  'footer.brand.line3': 'Transforma tu viaje interior',
  'footer.newsletter.title': 'Mantente Conectado',
  'footer.newsletter.placeholder': 'Tu correo electrónico',
  'footer.newsletter.privacy': 'Únete a nuestra comunidad de bienestar • Privacidad',
  'footer.explore.title': 'Explorar',
  'footer.explore.about': 'Acerca del Ayurveda',
  'footer.explore.schedule': 'Horario del Retiro',
  'footer.explore.testimonials': 'Testimonios',
  'footer.connect.title': 'Conectar',
  'footer.connect.email': 'Correo Electrónico',
  'footer.connect.instagram': 'Instagram',
  'footer.connect.facebook': 'Facebook',
  'footer.connect.whatsapp': 'WhatsApp',
  'footer.copyright': '© 2024 Retiro Swasthya. Todos los derechos reservados.',
  'footer.privacy': 'Política de Privacidad',
  'footer.terms': 'Términos de Servicio',
  'footer.builder': 'Creador de Sitios Web',

  // Villa Details
  'villa.amenities': 'Comodidades',
  'villa.amenity.bed': 'Cama King Size',
  'villa.amenity.bathroom': 'Baño Privado de Lujo',
  'villa.amenity.view': 'Vista Panorámica',
  'villa.amenity.meditation': 'Espacio de Meditación',
  'villa.amenity.terrace': 'Terraza Privada',
  'villa.amenity.ac': 'Aire Acondicionado',
  'villa.book': 'Reservar Esta Villa',
  'villa.back': 'Volver a Inicio',
};
